"use strict";
$(function ($) {
  const swiper02 = new Swiper(".swiper02", {
    loop: true,
    loopedSlides: 2,
    slidesPerView: "5",
    breakpoints: {
      320: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 4,
      },
      960: {
        slidesPerView: 5,
      },
    },
    speed: 8000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });

  const swiper03 = new Swiper(".swiper03", {
    loop: true,
    loopedSlides: 2,
    slidesPerView: "7.5",
    breakpoints: {
      320: { slidesPerView: 2.5, },
      768: { slidesPerView: 4, },
      1200: { slidesPerView: 7.5, },
    },
    speed: 8000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  });
});

"use strict";
$(function ($) {
  /* ----- qa accordion ----- */
  $('.qa__dt').click(function() {
    $(this).next().stop().slideToggle(400);
    $(this).toggleClass('is-active');
  });

  /* ----- accordion-sp ----- */
  $('.accordion__sp p').click(function() {
    $(this).next().stop().slideToggle(400);
    $(this).toggleClass('is-active');
  });
});

// タブの動き
$('.js-tab').on('click', function () {
  $('.js-tab, .parent__items').removeClass('is-active');
  $(this).addClass('is-active');
  const index = $('.js-tab').index(this);
  $('.parent__items').eq(index).addClass('is-active');
});

$('.js-info').on('click', function () {
  $('.js-info, .infomation__image').removeClass('is-active');
  $(this).addClass('is-active');
  const index = $('.js-info').index(this);
  $('.infomation__image').eq(index).addClass('is-active');
});

    /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });


// フェードイン
  $(function () {
    $(window).scroll(function () {
      const windowHeight = $(window).height();
      const scroll = $(window).scrollTop();

      $('.fade-in').each(function () {
        const targetPosition = $(this).offset().top;
        if (scroll > targetPosition - windowHeight + 100) {
          $(this).addClass("is-fadein");
        }
      });
    });
  });


/* ----- スムースクロール ----- */
$(function(){
  // #で始まるアンカーをクリックした場合に処理
  $('a[href^="#"]').click(function(){
    // 移動先を50px上にずらす
    var adjust = 100;
    // スクロールの速度
    var speed = 400; // ミリ秒
    // アンカーの値取得
    var href= $(this).attr("href");
    // 移動先を取得
    var target = $(href == "#" || href == "" ? 'html' : href);
    // 移動先を調整
    var position = target.offset().top - adjust;
    // スムーススクロール
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});

// .splideを持つ要素が存在する場合のみSplideを初期化する
const splideElement = document.querySelector('.splide');
if (splideElement) {
  const splide = new Splide(splideElement, {
     // autoplay: true, // 自動再生
    type: "loop", // ループ
    pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
    pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
    interval: 5000, // 自動再生の間隔
    speed: 1000, // スライダーの移動時間
    padding: "8%", // スライダーの左右の余白
    gap: 37, // スライド間の余白
    classes: {
    pagination: "splide__pagination your-class-pagination",
    page: "splide__pagination__page your-class-page",
  },
  breakpoints: {
    // 767px以下の場合の設定
    768: {
      padding: "10%",
      gap: 20, // スライド間の余白
      },
    },
  }).mount();
}

// モーダル
const modalButtons = document.querySelectorAll('.js-modal-button');
const modals = document.querySelectorAll('.js-modal');
const closeButton = document.querySelectorAll('.js-close-button');
const body = document.body;

function openModal(index) {
  modals[index].classList.add('is-open');
  body.style.overflow = 'hidden'; // スクロールを禁止する
}

function closeModal(index) {
  modals[index].classList.remove('is-open');
  body.style.overflow = ''; // スクロールを許可する
}

modalButtons.forEach((button, index) => {
  button.addEventListener('click', () => {
    openModal(index);
  });
});

closeButton.forEach((button, index) => {
  button.addEventListener('click', () => {
    closeModal(index);
  });
});

modals.forEach((modal, index) => {
  modal.addEventListener('click', event => {
    if (event.target === modal) {
      closeModal(index);
    }
  });
});

window.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    modals.forEach((modal, index) => {
      if (modal.classList.contains('is-open')) {
        closeModal(index);
      }
    });
  }
});


// パンフレット非表示ボタン
$(function () {
  // .close-btnをクリックすると
  $('.reserve-btn__close').on('click', function () {
    // .pamphlet-wrapのクラスに.hiddenクラスを付加する
    $('.reserve-btn').addClass('hidden');
  });
});



/* ----- スライダー ----- */
$('.fv-slider').slick({
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
  speed: 1000,
  pauseOnHover: false,
  dots: false,
  arrows: false,
  centerMode: true,
  asNavFor: '.navi-slider'
});

$('.fv-sub-slider').slick({
  slidesToShow: 4,
  asNavFor: '.fv-slider',
  dots: false,
  centerMode: true,
  focusOnSelect: true,
  centerPadding: '0px',
});

// $('.fv-circle').slick({
//   slidesToShow: 3,
//   asNavFor: '.fv-slider',
//   dots: false,
//   centerMode: true,
//   focusOnSelect: true,
//   centerPadding: '0px',
//   vertical: true,
// });

$('.fv-sub-slider').find('.slick-slide').click(function() {
  let slickIndex = $(this).data('slick-index');
  $('.fv-circle').find('.slick-slide').removeClass('slick-current');
  $('.fv-circle').find('.slick-slide[data-slick-index="' + slickIndex + '"]').addClass('slick-current');
})


/* ----- 下部CTA ----- */
document.addEventListener('DOMContentLoaded', () => {
  const fixedLink = document.querySelector('.baner');

  // 最初は非表示
  fixedLink.style.opacity = '0';
  fixedLink.style.visibility = 'hidden';

  document.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const showAfterScroll = 300; // 300pxスクロールしたら表示

    if (scrollTop + windowHeight >= documentHeight) {
      // ページの一番下に到達したら非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
    } else if (scrollTop > showAfterScroll) {
      // 300px以上スクロールしたら表示
      fixedLink.style.opacity = '1';
      fixedLink.style.visibility = 'visible';
    } else {
      // それ以外は非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
    }
  });
});
